<template>
  <div class="control container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6 col-sm-12 no-padding">
        <div class="btn-group btn-block" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-dark" @click="$emit('command', 'previous')">
            <i class="fa fa-chevron-circle-left" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-dark" @click="$emit('command', 'random')">
            <i class="fa fa-random" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-dark" @click="$emit('command', 'list')">
            <i class="fa fa-list" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-dark" @click="$emit('command', 'thumbnail')">
            <i class="fa fa-th" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-dark" @click="$emit('command', 'next')">
            <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="classifications.length > 0">
      <div class="col-lg-4 col-md-6 col-sm-12 no-padding">
        <div class="input-group mb-2">
          <div class="input-group-prepend ">
            <div class="input-group-text bg-dark text-white"><i class="fa fa-filter" aria-hidden="true"></i></div>
          </div>
          <select class="form-control bg-dark text-white"  v-model="classification" @change="$emit('change-classification', classification)">
            <option>Todas</option>
            <option v-for="classification in classifications">{{ classification }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "app-positions-control",
      props:{
        classifications: { type: Array, requite: true }
      },
      data: function () {
        return {
          classification: "Todas"
        }
      }
    }
</script>

<style scoped>
  .control {
    margin-bottom: 10px;
    margin-top: 5px;

  }

  .no-padding {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/app-positions-control.vue